import { render, staticRenderFns } from "./AddAdjustment.vue?vue&type=template&id=cb0bef08"
import script from "./AddAdjustment.vue?vue&type=script&lang=js"
export * from "./AddAdjustment.vue?vue&type=script&lang=js"
import style0 from "./AddAdjustment.vue?vue&type=style&index=0&id=cb0bef08&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports